import { Dimensions } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
var height = Dimensions.get('window').height;
export default CustomStyleSheet({
  'order-list-popup-group-order-wrapper': {
    borderWidth: 1,
    borderColor: '#f69113',
    marginBottom: 10
  },
  'food-order-banner': {
    borderTopWidth: 1,
    borderTopColor: 'rgba(0, 0, 0, 0.09)',
    borderStyle: 'solid'
  },
  'order-list-popup-banner': {
    margin: 0,
    padding: 0,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 12,
    textAlign: 'left',
    backgroundColor: '#f69113',
    fontSize: 14,
    lineHeight: 16,
    color: '#fff'
  },
  'order-list-popup-title': {
    textAlign: 'center'
  },
  'order-list-popup-content': {
    backgroundColor: '#f5f5f5',
    height: height * 0.8
  },
  'order-list-popup-tabs-content-class': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden'
  },
  'order-list-popup-tabs-title-class': {
    backgroundColor: '#fff',
    display: 'flex'
  },
  'order-list-popup-list-wrapper': {
    marginTop: 8,
    marginBottom: 0,
    marginRight: 7,
    marginLeft: 7,
    height: '100%'
  },
  // list 组件
  'order-list-popup__img_wrapper': {
    paddingTop: 60,
    textAlign: 'center',
    alignItems: 'center'
  },
  'order-list-popup__img': {
    height: 200,
    width: 200
  },
  'order-list-popup__img_text': {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: -50
  },
  'order-list-popup--loading': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  }
});